import { DateRange } from 'components/DateRangeFilter/Dropdown';
import { STORAGE_RECENT_DATE_RANGES } from 'constants/localStorage';

export interface RecentRange extends DateRange {
  from?: Date;
  to?: Date;
  label: string;
  timestamp: number;
}

const MAX_RECENT_RANGES = 5;

export const getRecentRanges = (): RecentRange[] => {
  try {
    const stored = localStorage.getItem(STORAGE_RECENT_DATE_RANGES);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
};

export const addRecentRange = (range: DateRange, label: string) => {
  try {
    const recent = getRecentRanges();

    const newRange: RecentRange = {
      from: range.from,
      to: range.to,
      label,
      timestamp: Date.now(),
    };

    // Remove duplicates and add new range
    const updated = [
      newRange,
      ...recent.filter((r) => r.label !== label),
    ].slice(0, MAX_RECENT_RANGES);

    localStorage.setItem(STORAGE_RECENT_DATE_RANGES, JSON.stringify(updated));
    return updated;
  } catch {
    return [];
  }
};
